<template>
  <div class="Context" v-title data-title="“北京日”签到">
    <Head></Head>
    <div class="Border">
      <el-result icon="warning" style="padding:10px 0px;"></el-result>
      <p>尚未报名</p>
      <span>您尚未报名参加服贸会,</span>
      <span>请联系相关工作人员报名！</span>
      <span></span>
    </div>
  </div>
</template>

<script>

import Head from '@/components/head.vue';
export default {
  name: "Registered",
  components:{
      Head
  },
  data() {
    return {
        Data:{}
    }
  },
  created(){
    if(window.localStorage.getItem('SuccessData') != null){
      this.Data = JSON.parse(window.localStorage.getItem('SuccessData'));
    }else{
      this.$message({
        message: '请先签到',
        type: 'error'
      });
      this.$router.push({path: '/mobile/enlist',query:{}});
    }
  },
  methods: {}
}
</script>
<style scoped>
    .Context{
        width: 100%;
        height: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
    }
    .Border{
      width: 95%;
      height: 280px;
      border: 1px solid rgba(250, 205, 145, 1);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 44px;
    }
    .Border>p{
      font-size: 20px;
      color: #F64B00;
      font-weight: 600;
      margin-top: 20px;
    }
    .Border>span{
      font-size: 20px;
      margin-top: 20px;
    }
</style>
